import { Component, Input, OnInit } from '@angular/core';
import { FormDomainScriptGuideHeatmapsService } from '../features/heatmaps/service/heatmaps.service';
import { FormDomainScriptGuidePageFixService } from '../features/page-fix/service/page-fix.service';
import { FormDomainScriptGuideStatisticsService } from '../features/statistics/statistics.service';
import {
    FormDomainScriptGuidePageAssistService,
} from '@client/app/forms/domain-script-guide/features/page-assist/form-domain-script-guide-page-assist.service';

@Component({
    selector: 'form-domain-script-guide-legacy',
    standalone: false,
    templateUrl: './legacy.html',
})
export class FormDomainScriptGuideLegacyComponent implements OnInit {
    @Input() domain: any;
    @Input() pageAssistModel: any;

    id: string = '';

    constructor (
        private formDomainScriptGuideHeatmapsService: FormDomainScriptGuideHeatmapsService,
        private formDomainScriptGuidePageFixService: FormDomainScriptGuidePageFixService,
        private formDomainScriptGuideStatisticsService: FormDomainScriptGuideStatisticsService,
        private formDomainScriptGuidePageAssistService: FormDomainScriptGuidePageAssistService,
    ) {}

    ngOnInit () {
        this.activate();
    }

    activate () {
        this.id = 'script' + Math.floor(Math.random() * 100);
    }

    updatePageAssistSettings (settings: any) {
        this.pageAssistModel.legacySettings = settings;
    }

    getVariables () {
        let scripts = this.tab() + '_monsido.push([\'_setDomainToken\', \'' + this.domain.token + '\']);\n';
        scripts +=
            this.tab(2) +
            '_monsido.push([\'_withStatistics\', \'' +
            this.stringify(this.formDomainScriptGuideStatisticsService.getValue()) +
            '\']);';

        if (
            this.formDomainScriptGuidePageAssistService.getAccessToFeature(this.domain) &&
            this.pageAssistModel.legacySettings.enabled
        ) {
            if (this.pageAssistModel.legacySettings.theme) {
                scripts +=
                    '\n' +
                    this.tab() +
                    'var _monsido_page_assist_theme = ' +
                    this.stringify(this.pageAssistModel.legacySettings.theme) +
                    ';';
            }
            if (this.pageAssistModel.legacySettings.direction) {
                scripts +=
                    '\n' +
                    this.tab() +
                    'var _monsido_page_assist_direction = ' +
                    this.stringify(this.pageAssistModel.legacySettings.direction) +
                    ';';
            }
            scripts +=
                '\n' +
                this.tab() +
                'var _monsido_skip_to_pageassist = ' +
                this.stringify(this.pageAssistModel.legacySettings.skip_to) +
                ';';
        }
        return scripts;
    }

    getExternalScripts () {
        let result = '';

        if (
            this.formDomainScriptGuidePageAssistService.getAccessToFeature(this.domain) &&
            this.pageAssistModel.legacySettings.enabled
        ) {
            result +=
                '&lt;script async src="//cdn.monsido.com/page-assist/mon-page-assist.js"&gt;&lt;/script&gt;\n';
        }

        if (this.formDomainScriptGuidePageFixService.getValue()) {
            result +=
                '&lt;script async type="text/javascript" src="//pagecorrect.monsido.com/v1/page-correct.js"&gt;&lt;/script&gt;\n';
        }

        if (this.formDomainScriptGuideHeatmapsService.getValue()) {
            result +=
                '&lt;script async type="text/javascript" src="//heatmaps.monsido.com/v1/heatmaps.js"&gt;&lt;/script&gt;\n';
        }

        return result;
    }

    private stringify (value: any) {
        return JSON.stringify(value);
    }

    private tab (times: number = 1) {
        let result = '';
        for (let i = 0; i < times; i++) {
            result = result + '&nbsp;&nbsp;&nbsp;&nbsp;';
        }
        return result;
    }
}
